export default "__VITE_ASSET__121272bf__"